import { createSlice } from '@reduxjs/toolkit';
import { getBatchParameters } from 'ducks/batch-parameters/operators';
import { Slices } from 'ducks/slices';
import { ProjectParameters } from 'ducks/types/store-types';
import { normalizeParameters } from 'ducks/utils';

const initialState: ProjectParameters = [];

const batchParametersSlice = createSlice({
  name: Slices.BATCH_PARAMETERS,
  initialState,
  reducers: {
    clearParameters: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBatchParameters.pending, () => {
        return initialState;
      })
      .addCase(getBatchParameters.fulfilled, (_, { payload }) => {
        return normalizeParameters(payload);
      });
  },
});

export const { clearParameters } = batchParametersSlice.actions;

export default batchParametersSlice.reducer;
